import { __, always, concat, identity, ifElse, pathOr, pipe } from 'ramda'

const discountParser = ifElse(
  Boolean,
  pipe(String, concat(__, '%')),
  always(undefined),
)

const subscriptionFeatures = [
  {
    id: 'recordings',
    name: 'Past session recordings',
    key: 'recordings',
    parser: identity,
    condition: always(true),
    showAfterPurchase: true,
  },
  {
    id: 'bcs',
    name: 'Free Masterclasses or Workshops',
    key: 'broadcastClasses',
    parser: identity,
    condition: pipe(
      pathOr(0, ['purchasedModel', 'broadcastClasses']),
      Number,
      Boolean,
    ),
    showAfterPurchase: true,
  },
  {
    id: 'liveChat',
    name: 'Video chat with Artists',
    key: 'liveChat',
    parser: identity,
    condition: always(true),
    showAfterPurchase: true,
  },
  {
    id: 'bc-discount',
    name: 'Discount on Live Sessions',
    key: 'discountBc',
    parser: discountParser,
    condition: always(true),
    showAfterPurchase: true,
  },
  {
    id: 'c-discount',
    name: 'Discount on courses',
    key: 'discountCourse',
    parser: discountParser,
    condition: always(true),
    showAfterPurchase: true,
  },
  {
    id: 'rc-discount',
    name: 'Discount on recorded courses',
    key: 'discountRecorded',
    parser: discountParser,
    condition: always(true),
    showAfterPurchase: true,
  },
]

export default subscriptionFeatures
